import type { SITE_MODULATORS_CARD_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/site-modulators-card/site-modulators-card.fr.ts";

export const SITE_MODULATORS_CARD_ENGLISH_LOCALE = {
  title: "Installed modulators on site",
} satisfies typeof SITE_MODULATORS_CARD_FRENCH_LOCALE;
